import { isInFullscreen } from '@shared/utils/detectFullscreenChange';

// Fullscreen APIs can reject in embedded WebViews even when the method exists.
function ignoreUnsupportedFullscreen(error) {
	if (error?.name === 'TypeError' || error?.message === 'Fullscreen is not supported') {
		return;
	}

	throw error;
}

function callFullscreenMethod(target, methodName) {
	return Promise.resolve(target[methodName]()).catch(ignoreUnsupportedFullscreen);
}

export default function(element) {
	if (isInFullscreen()) {
		if (document.exitFullscreen) {
			return callFullscreenMethod(document, 'exitFullscreen');
		} else if (document.mozCancelFullScreen) {
			document.mozCancelFullScreen();
		} else if (document.webkitExitFullscreen) {
			document.webkitExitFullscreen();
		} else if (document.msExitFullscreen) {
			document.msExitFullscreen();
		}
	} else if (element) {
		if (element.requestFullscreen) {
			return callFullscreenMethod(element, 'requestFullscreen');
		} else if (element.mozRequestFullScreen) {
			element.mozRequestFullScreen();
		} else if (element.webkitRequestFullscreen) {
			return callFullscreenMethod(element, 'webkitRequestFullscreen');
		} else if (element.msRequestFullscreen) {
			return callFullscreenMethod(element, 'msRequestFullscreen');
		} else if (element.webkitEnterFullscreen) {
			element.webkitEnterFullscreen();
		}
	}
}
